module.exports = __webpack_public_path__ + "static/media/01.6ab0d4ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/_portfolio/01.jpg
// module id = 282
// module chunks = 0